var Acr = Acr || {};

Acr.Tooltip = function () {
  
  var utility = window.Utility;

  var $element;
  var $closeButton;

  var closeButton = '.js-close';

  function showTooltip() {
    $element.removeAttr('style');
  }

  function hideTooltip() {
    $element.hide();
  }

  // TODO: Remove jquery from this function
  function initZipcode() {
    var zipcode = utility.getUrlParameterValue('zipcode') || utility.getCookie('zipcode');
    if (!zipcode) {
      showTooltip();
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $closeButton = $element.find(closeButton);
  }

  function bindEvents() {
    $closeButton.click(hideTooltip);

    window.addEventListener('zipcodeUpdate', hideTooltip);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    initZipcode();
  }

  return {
    init: init,
  };
};
